export function ensureDir(fileSystem, dir) {
    try {
        fileSystem.mkdir(dir);
    }
    catch (_a) {
        // ignore
    }
}
//# sourceMappingURL=utils.js.map